import Vue from 'vue'
import VtLoadingButton from '@/components/common/vt-loading-button/vt-loading-button.vue'
Vue.component('VtLoadingButton', VtLoadingButton)
